<template>
    <div class="no-data-wrap">
        <div class="no-data">
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    name: 'nodata',
};
</script>
<style scoped></style>
